import cloneDeep from 'lodash.clonedeep'

export const filterBubbles = [
    { filterUid: 'permanent', filterField: 'typeOfEmployment', label: 'Full-time' },
    { filterUid: 'part-time', filterField: 'typeOfEmployment', label: 'Part-time' },
    // Maybe these are needed in the future again
    // { filterUid: true, filterField: 'location', label: 'Homeoffice' },
    // { filterUid: 'information_technology', filterField: 'function', label: 'Information Technology' },
    // { filterUid: 'legal', filterField: 'function', label: 'Legal' },
    // { filterUid: 'human_resources', filterField: 'function', label: 'Human Resources' },
]

/**
 * Get all jobs which comply to the current active filters
 *
 * @param allJobs
 * @param activeFilterTagUids
 * @returns {*}
 */
export const getFilteredAndSearchedJobs = (allJobs, activeFilterTagUids) => {
    // optimization: if there is no filter active: return all jobs
    if (activeFilterTagUids.length === 0) {
        return allJobs
    }

    // filter out all jobs which don't comply with the currently selected filters
    return allJobs.filter((job) => {
        const activeFilterTagUidsArray = Array.from(activeFilterTagUids)
        return activeFilterTagUidsArray.every((filter) => {
            if (job.hasOwnProperty(filter.filterField)) {
                return Object.values(job[filter.filterField]).includes(formatId(filter.filterField, filter.filterUid))
            }
        })
    })
}

/**
 * Returns available Categories and Tags based on given Jobs
 * @param searchedJobs
 * @param activeFilterTagUids
 * @param allFilters
 * @returns {{filteredAndSearchedJobs: Object, availableFilters: Object}}
 */
export const getFilteredItems = (searchedJobs, activeFilterTagUids, allFilters) => {
    const filteredAndSearchedJobs = getFilteredAndSearchedJobs(searchedJobs, activeFilterTagUids)
    // const availableFilters = getAvailableFilters(allFilters, filteredAndSearchedJobs)
    const filterBubbles = getFilterBubbles(filteredAndSearchedJobs)

    return {
        filteredAndSearchedJobs: () => filteredAndSearchedJobs,
        availableFilters: () => allFilters,
        filterBubbles: () => filterBubbles,
    }
}

export const getFilterBubbles = (filteredAndSearchedJobs) => {
    let newBubbles = []
    filterBubbles.map((filter) => {
        const property = filter.filterField === 'location' ? 'remote' : 'id'
        const newJobs = filteredAndSearchedJobs.filter((job) => job[filter.filterField][property] === filter.filterUid)
        newBubbles = [
            ...newBubbles,
            {
                ...filter,
                count: newJobs.length,
            },
        ]
    })

    return newBubbles
}

export const setFilterStateDropdown = (activeFilterTagUids, newFilterField, newFilterUid) => {
    if (activeFilterTagUids.length !== 0) {
        activeFilterTagUids = activeFilterTagUids.filter((filter) => filter.filterField !== newFilterField)
    }

    if (newFilterUid === '') {
        return activeFilterTagUids
    }
    activeFilterTagUids = [...activeFilterTagUids, { filterUid: newFilterUid, filterField: newFilterField }]

    return activeFilterTagUids
}

export const setFilterStateCheckbox = (activeFilterTagUids, filterField, filterUid, isChecked) => {
    if (isChecked) {
        activeFilterTagUids = [...activeFilterTagUids, { filterUid, filterField }]
    } else {
        activeFilterTagUids = activeFilterTagUids.filter((filter) => filter.filterUid !== filterUid)
    }

    return activeFilterTagUids
}

const formatId = (filterField, filterUid) => {
    if (filterField === 'location' && typeof filterUid === 'string') {
        return filterUid.split('-')[0]
    }
    return filterUid
}
